import sdl from '@jds/react-generated-sdl/JDSText';
import type { JDSTextProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TextProps } from '../logic';

const Component = (props: TextProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    color = 'primary_grey_100',
    textAlign = 'left',
    textDecoration = 'none',
    appearance = 'body_s',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { color, textAlign, textDecoration, appearance, ...rest },
    'JDSText',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Text = withLogic(Component) as React.FC<TextProps> & {
  slotName?: string;
};

Text.displayName = 'Text';
Text.slotName = 'jds_text';

export { Text, type JDSTextProps };
